import React from 'react';
import { Typography, Box, List, ListItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Business, Phone, Email } from '@mui/icons-material';

const ContactInfoXs = () => {
  const { t } = useTranslation();
  
  return (
    <Box>
      <Typography 
        variant="subtitle2" 
        fontWeight="600" 
        sx={{ 
          mb: 2,
          color: '#333'
        }}
      >
        {t('privacy-policy.personal-data-notice.contact_info.title')}
      </Typography>
      
      <Typography 
        variant="body2" 
        sx={{ 
          color: '#666',
          mb: 1.5
        }}
      >
        {t('privacy-policy.personal-data-notice.contact_info.department')}
      </Typography>
      
      <List disablePadding sx={{ mt: 1 }}>
        <ListItem 
          disableGutters 
          sx={{ 
            px: 0, 
            py: 1
          }}
        >
          <ListItemIcon sx={{ minWidth: 40 }}>
            <Business sx={{ color: '#007AFF', fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText 
            primary={t('privacy-policy.personal-data-notice.contact_info.address')} 
            primaryTypographyProps={{
              variant: 'body2',
              sx: { color: '#333' }
            }}
          />
        </ListItem>
        
        <Divider variant="inset" sx={{ ml: 0 }} />
        
        <ListItem 
          disableGutters 
          sx={{ 
            px: 0, 
            py: 1
          }}
        >
          <ListItemIcon sx={{ minWidth: 40 }}>
            <Phone sx={{ color: '#007AFF', fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText 
            primary={t('privacy-policy.personal-data-notice.contact_info.phone')} 
            primaryTypographyProps={{
              variant: 'body2',
              sx: { color: '#333' }
            }}
          />
        </ListItem>
        
        <Divider variant="inset" sx={{ ml: 0 }} />
        
        <ListItem 
          disableGutters 
          sx={{ 
            px: 0, 
            py: 1
          }}
        >
          <ListItemIcon sx={{ minWidth: 40 }}>
            <Email sx={{ color: '#007AFF', fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText 
            primary={t('privacy-policy.personal-data-notice.contact_info.email')} 
            primaryTypographyProps={{
              variant: 'body2',
              sx: { color: '#333' }
            }}
          />
        </ListItem>
      </List>
    </Box>
  );
};

export default ContactInfoXs;